import React from 'react'
import { Grid, Divider, TextField, Typography, FormControl, RadioGroup, Radio, CircularProgress } from '@material-ui/core'
import { Page, Header, CustomButton, SecaoGenerica } from 'components'
import Autocomplete from '@material-ui/lab/Autocomplete'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { cutMaxLength } from 'utils/helpers'
import useStyles from './styles'
import { useExtracaoVestigio } from './hooks/useExtracaoVestigio'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)
const maxLength4000 = (newValue) => cutMaxLength(newValue, 4000)

export const ExtracaoVestigio = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    formExtracao,
    processando,
    tiposVestigios,
    processandoTiposVestigios,
    processandoTiposVestigiosEspecificos,
    opcoesTiposVestigiosEspecificosAtual,
    casosDoObjetoOrigem,
    currentUser,
    formError,
    handleChangeTipoVestigioGenerica,
    handleConfirmarExtracao,
    handleEditarVestigio,
    router,
  } = useExtracaoVestigio({ route })

  const isFormLoading = processandoTiposVestigiosEspecificos || processandoTiposVestigios

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      {isFormLoading ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container style={{ marginTop: '16px' }}>
          {/* Seção: Dados da Embalagem */}

          <Grid item container spacing={2}>
            <Grid item md={3} sm={6} xs={12}>
              <TextField
                id="lacre"
                error={formExtracao.hasError('lacre')}
                label="NÚMERO DO LACRE"
                fullWidth
                helperText={formExtracao.hasError('lacre') ? formExtracao.formState.errors.lacre[0] : null}
                variant="outlined"
                name="lacre"
                onChange={(e) => formExtracao.handleChangeWithModification(e, maxLength250)}
                value={formExtracao.formState.values.lacre || null}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
                Caracteres restantes: {250 - (formExtracao.formState.values.lacre?.length ? formExtracao.formState.values.lacre.length : 0)}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>TIPO DA EMBALAGEM *</Typography>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup
                  aria-label="tipo-embalagem"
                  name="tipoEmbalagem"
                  value={formExtracao.formState.values.tipoEmbalagem || null}
                  onChange={formExtracao.handleChange}
                  style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}
                >
                  <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                  <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                  <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                  <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />
                  <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                  <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
                </RadioGroup>
              </FormControl>
            </Grid>

            {formExtracao.formState.values.tipoEmbalagem === 'OUTRO' && (
              <Grid item xs={12}>
                <TextField
                  label="OUTRO TIPO DE EMBALAGEM"
                  name="outroTipoEmbalagem"
                  variant="outlined"
                  value={formExtracao.formState.values.outroTipoEmbalagem || ''}
                  onChange={formExtracao.handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}

          </Grid>



          <SecaoGenerica titulo="Características do Vestígio" spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                value={formExtracao.formState.values.tiposGens || []}
                name="tiposGens"
                multiple
                noOptionsText="Sem informações"
                options={tiposVestigios || []}
                onChange={(event, newValue) => {
                  handleChangeTipoVestigioGenerica(event, newValue)
                }}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.nome?.toUpperCase()}
                renderOption={(option) => option.nome?.toUpperCase()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={!formExtracao.formState.values.tiposGens?.length && 'Selecionar...'}
                    label="NATUREZA PRELIMINAR DO VESTÍGIO (GENÉRICA)"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={formExtracao.hasError('tiposGens')}
                    helperText={formExtracao.hasError('tiposGens') ? formExtracao.formState.errors.tiposGens[0] : null}
                  />
                )}
                className={classes.tipoVestigio}
              />
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                value={formExtracao.formState.values.tiposEsps || []}
                name="tiposEsps"
                multiple
                noOptionsText="Sem informações"
                options={opcoesTiposVestigiosEspecificosAtual || []}
                onChange={(event, newValue) => {
                  formExtracao.handleChangeNewValueByNameProperty(event, newValue, 'tiposEsps')
                }}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.nome?.toUpperCase()}
                renderOption={(option) => option.nome?.toUpperCase()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={!formExtracao.formState.values.tiposEsps?.length && 'Selecionar...'}
                    label="NATUREZA PRELIMINAR DO VESTÍGIO (ESPECÍFICA)"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={formExtracao.hasError('tiposEsps')}
                    helperText={formExtracao.hasError('tiposEsps') ? formExtracao.formState.errors.tiposEsps[0] : null}
                  />
                )}
                className={classes.tipoVestigio}
              />
            </Grid>

            {formExtracao.formState.values.tiposEsps?.some((tipoEspecifico) => tipoEspecifico.identificador === 'OBJETO') && (
              <Grid item xs={12}>
                <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>TAMANHO DO OBJETO</Typography>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup aria-label="tamanhoObjeto" name="tamanhoObjeto" value={formExtracao.formState.values.tamanhoObjeto || null} onChange={formExtracao.handleChange} style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
                    <FormControlLabel value="PEQUENO" control={<Radio />} label={<Typography variant="body2">PEQUENO</Typography>} />
                    <FormControlLabel value="MEDIO" control={<Radio />} label={<Typography variant="body2">MÉDIO</Typography>} />
                    <FormControlLabel value="GRANDE" control={<Radio />} label={<Typography variant="body2">GRANDE</Typography>} />
                  </RadioGroup>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="DESCRIÇÃO"
                multiline
                minRows={5}
                required
                fullWidth
                value={formExtracao.formState.values.descricao || ''}
                InputLabelProps={{
                  shrink: true,
                }}
                name="descricao"
                onChange={(e) => formExtracao.handleChangeWithModification(e, maxLength4000)}
                error={formExtracao.hasError('descricao')}
                helperText={formExtracao.hasError('descricao') ? formExtracao.formState.errors.descricao[0] : null}
              />
              <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
                Caracteres restantes: {4000 - (formExtracao.formState.values.descricao?.length ? formExtracao.formState.values.descricao.length : 0)}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel control={<Checkbox checked={!!formExtracao.formState.values.contraprova} onChange={formExtracao.handleChange} name="contraprova" />} label="Trata-se de uma contraprova" />
            </Grid>
          </SecaoGenerica>



          <SecaoGenerica titulo="Custódia Inicial" spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                name="setorAtual"
                value={formExtracao.formState.values.setorAtual || null}
                noOptionsText="Sem informações"
                options={currentUser && currentUser.setores ? currentUser.setores : []}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) => formExtracao.handleChangeNewValueByNameProperty(event, newValue, 'setorAtual')}
                getOptionLabel={(option) => `${option.nome?.toUpperCase()} - ${option.sigla} / ${option.divisao?.regional?.nome?.toUpperCase()}`}
                renderOption={(option) => `${option.nome?.toUpperCase()} - ${option.sigla} / ${option.divisao?.regional?.nome?.toUpperCase()}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="SELECIONAR..."
                    label="SETOR INICIAL DO VESTÍGIO (A LISTA CONTÉM OS SETORES QUE VOCÊ FAZ PARTE)"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </Grid>
          </SecaoGenerica>

          {/* Seção: Caso a ser Inserido */}
          {route.origem !== 'CADAVER' && !route.editar && (

            <SecaoGenerica titulo="Caso a ser Inserido" spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  name="caso"
                  value={formExtracao.formState.values.caso || null}
                  noOptionsText="Sem informações"
                  options={casosDoObjetoOrigem || []}
                  getOptionSelected={(option, value) => option.id === value.id}
                  onChange={(event, newValue) => formExtracao.handleChangeNewValueByNameProperty(event, newValue, 'caso')}
                  getOptionLabel={(option) => `${option.identificador?.toUpperCase()}`}
                  renderOption={(option) => `${option.identificador?.toUpperCase()}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder=""
                      required
                      label="SELECIONE O CASO"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>
            </SecaoGenerica>

          )}

          {/* Ações / Botões do rodapé */}
          <Grid item xs={12}>
            <Divider style={{ margin: '16px 0' }} />
            <Grid container justifyContent="space-between" spacing={1} className={classes.buttons}>
              <Grid item>
                <CustomButton
                  variant="outlined"
                  colorType="primary"
                  startIcon={<ArrowBackIcon />}
                  onClick={() => router.history.goBack()}
                >
                  Voltar
                </CustomButton>
              </Grid>
              <Grid item>
                <CustomButton
                  variant="contained"
                  colorType="secondary"
                  onClick={() => (route.editar ? handleEditarVestigio() : handleConfirmarExtracao())}
                  disabled={formError() || processando}
                  isLoading={processando}
                >
                  Confirmar
                </CustomButton>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      )}
    </Page>
  )
}
export default ExtracaoVestigio
